/**
 * SEO Constants - Derived from routes configuration
 *
 * This file now serves as a bridge that exports SEO metadata derived from routes/index.js
 * Previously, this file contained static duplicated data that could get out of sync with routes.
 *
 * Now, routes/index.js is the SINGLE SOURCE OF TRUTH for all page metadata including:
 * - Page title
 * - SEO description
 * - Full URL link
 * - Canonical URLs
 *
 * Benefits:
 * ✅ No duplication - maintain metadata in one place
 * ✅ Single source of truth - routes drive everything
 * ✅ Less maintenance - update routes once, everything stays in sync
 * ✅ Type-safe - metadata is co-located with route definitions
 */

import { buildSeoPages, getRouteByPath } from "lib/route-seo-utils";

// Export SEO_PAGES object built from routes configuration using a Proxy
// to prevent circular dependency initialization issues
let seoPagesCache = null;

export const SEO_PAGES = new Proxy({}, {
  get(target, prop) {
    if (!seoPagesCache) {
      seoPagesCache = buildSeoPages();
    }
    return seoPagesCache[prop];
  },
  ownKeys(target) {
    if (!seoPagesCache) {
      seoPagesCache = buildSeoPages();
    }
    return Reflect.ownKeys(seoPagesCache);
  },
  getOwnPropertyDescriptor(target, prop) {
    if (!seoPagesCache) {
      seoPagesCache = buildSeoPages();
    }
    return Reflect.getOwnPropertyDescriptor(seoPagesCache, prop);
  }
});


/**
 * Helper function to get SEO data for a specific route path
 * Usage: const seoData = getSeoByPath('/profileedit');
 */
export const getSeoByPath = getRouteByPath;
